import { summaryTableStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsSummaryTable";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

summaryTableStyles.titleItem = {
    ...summaryTableStyles.titleItem,
    css: css`
        padding-top: 40px;
        padding-bottom: 0;
    `,
};
summaryTableStyles.title = {
    ...summaryTableStyles.title,
    size: 32,
    css: css`
        border: none;
        padding-block: 0;
    `,
};

summaryTableStyles.lineItem = {
    ...summaryTableStyles.lineItem,
    css: css`
        ${summaryTableStyles.lineItem?.css}
        border: none;
        padding-block: 0;

        & > div {
            margin-top: 24px;
        }

        &:first-child {
            margin-top: 0;
        }
    `,
};

summaryTableStyles.lineStyles = {
    ...summaryTableStyles.lineStyles,
    container: {
        ...summaryTableStyles.lineStyles?.container,
        css: css`
            ${summaryTableStyles.lineStyles?.container?.css}
            border: 1px solid ${getColor(colorStrings.commonBorder)};
            border-radius: 4px;
            padding: 16px;
        `,
    },

    partItem: {
        ...summaryTableStyles.lineStyles?.partItem,
        width: 12,
        printWidth: 12,
    },
    myPartItem: {
        ...summaryTableStyles.lineStyles?.myPartItem,
        width: 12,
        printWidth: 12,
    },
    mgfItem: {
        ...summaryTableStyles.lineStyles?.mgfItem,
        width: 12,
        printWidth: 12,
    },

    partStyles: {
        ...summaryTableStyles.lineStyles?.partStyles,
        wrapper: {
            ...summaryTableStyles.lineStyles?.partStyles?.wrapper,
            css: css`
                flex-direction: row;
                p,
                span {
                    width: fit-content;
                    &:first-child {
                        margin-right: 8px;
                    }
                }
            `,
        },
    },
    myPartStyles: {
        ...summaryTableStyles.lineStyles?.myPartStyles,
        wrapper: {
            ...summaryTableStyles.lineStyles?.myPartStyles?.wrapper,
            css: css`
                flex-direction: row;
                p,
                span {
                    width: fit-content;
                    &:first-child {
                        margin-right: 5px;
                    }
                }
            `,
        },
    },
    mgfStyles: {
        ...summaryTableStyles.lineStyles?.mgfStyles,
        wrapper: {
            ...summaryTableStyles.lineStyles?.mgfStyles?.wrapper,
            css: css`
                flex-direction: row;
                p,
                span {
                    width: fit-content;
                    &:first-child {
                        margin-right: 8px;
                    }
                }
            `,
        },
    },

    infoLeftColumn: {
        ...summaryTableStyles.lineStyles?.infoLeftColumn,
        width: [12, 12, 10, 6, 6],
        printWidth: 6,
    },

    infoRightColumn: {
        ...summaryTableStyles.lineStyles?.infoRightColumn,
        width: [12, 12, 2, 6, 6],
        printWidth: 6,
    },

    priceItem: {
        ...summaryTableStyles.lineStyles?.priceItem,
        width: [6, 6, 12, 4, 4],
        printWidth: 4,
        css: css`
            flex-direction: column;
        `,
    },

    priceStyles: {
        ...summaryTableStyles.lineStyles?.priceStyles,
        text: {
            weight: "normal",
        },
    },

    qtyItem: {
        ...summaryTableStyles.lineStyles?.qtyItem,
        width: [6, 6, 12, 4, 4],
        printWidth: 4,
    },
};
